import type { OfflineMutation } from './OfflineDB'

type QueuedMutation = Pick<OfflineMutation, 'type' | 'uuid' | 'status' | 'enqueuedAt' | 'newStatus'>

/**
 * Чи є нова зміна статусу дублем: лише якщо ОСТАННЯ pending-мутація цього завдання —
 * та сама зміна статусу (подвійне натискання). Повтор статусу після інших кроків —
 * легітимний: «Нова ходка» знову веде в «Розпочато завантаження».
 */
export const isDuplicateStatusChange = (
    queue: QueuedMutation[],
    mutation: Pick<OfflineMutation, 'type' | 'uuid' | 'newStatus'>
): boolean => {
    if (mutation.type !== 'status-change') return false
    const last = queue
        .filter((m) => m.uuid === mutation.uuid && m.status === 'pending')
        .sort((a, b) => a.enqueuedAt - b.enqueuedAt)
        .at(-1)
    return last?.type === 'status-change' && last.newStatus === mutation.newStatus
}
